/**
 * Console Experience Redesign (F65) — shared constants.
 *
 * The redesign ships behind the `console_experience_redesign` feature flag.
 * When the flag is on, the shell sets `data-console-redesign="true"` on the
 * document element (wired in Slice 2); the token overrides in
 * `styles/console-redesign.css` and the shared primitives key off that
 * attribute. With the flag off the attribute is absent and the current shell
 * renders unchanged.
 */

export const CONSOLE_REDESIGN_FLAG = "console_experience_redesign";

export const CONSOLE_REDESIGN_ATTR = "data-console-redesign";
